import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { teacherDayTimetableService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as teacherDayTimetable from './actions';

export function getTeacherDayTimetable(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_TEACHERDAY_TIMETABLE),
    mergeMap(({ payload }) => {
      return teacherDayTimetableService.getTeacherDayTimetable(payload).pipe(
        map((res) =>
        teacherDayTimetable.getTeacherDayTimetableSuccess(
            res.responceObject.records
          )
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
